import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from '../../services/api'
import LoadingSpinner from '../../components/LoadingSpinner'

/**
 * MentorParticipants — all participants assigned to this mentor, across projects.
 */
export default function MentorParticipants() {
  const [participants, setParticipants] = useState(null)

  useEffect(() => {
    api.get('/project-lab/mentor/participants')
      .then((r) => setParticipants(r.data.participants))
      .catch(() => setParticipants([]))
  }, [])

  if (participants === null) return <div className="flex justify-center py-16"><LoadingSpinner /></div>

  return (
    <div className="max-w-5xl space-y-6">
      <header>
        <h1 className="font-display text-2xl text-white">Participants</h1>
        <p className="text-xs text-cinema-muted mt-1">Participants assigned to you across Project Lab.</p>
      </header>

      {participants.length === 0 ? (
        <p className="text-sm text-cinema-muted py-6 border-t border-white/10">No participants assigned yet.</p>
      ) : (
        <div className="border-t border-white/10 overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-white/10">
                <th className="py-3 pr-4 text-[10px] uppercase tracking-widest text-cinema-muted font-mono font-normal">Participant</th>
                <th className="py-3 pr-4 text-[10px] uppercase tracking-widest text-cinema-muted font-mono font-normal">Project</th>
                <th className="py-3 pr-4 text-[10px] uppercase tracking-widest text-cinema-muted font-mono font-normal">Mode</th>
                <th className="py-3 pr-4 text-[10px] uppercase tracking-widest text-cinema-muted font-mono font-normal">Current Stage</th>
                <th className="py-3 text-[10px] uppercase tracking-widest text-cinema-muted font-mono font-normal">Status</th>
                <th className="py-3 pl-4 text-right text-[10px] uppercase tracking-widest text-cinema-muted font-mono font-normal">Review</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {participants.map((pt) => (
                <tr key={pt.enrollment_id}>
                  <td className="py-3.5 pr-4">
                    <Link to={`/mentor/enrollments/${pt.enrollment_id}`} className="group">
                      <p className="text-sm text-white group-hover:text-cinema-gold transition-colors">{pt.student_first_name} {pt.student_last_name}</p>
                      <p className="text-xs text-cinema-muted">{pt.student_email}</p>
                    </Link>
                  </td>
                  <td className="py-3.5 pr-4 text-sm text-cinema-soft">{pt.project_title}</td>
                  <td className="py-3.5 pr-4 text-xs text-cinema-muted capitalize">{pt.mode}</td>
                  <td className="py-3.5 pr-4 text-xs text-cinema-soft">
                    {pt.current_stage_title || `Stage ${pt.current_stage_index}`}
                  </td>
                  <td className="py-3.5 text-xs">
                    <span className={`uppercase tracking-wider text-[10px] font-mono ${
                      pt.current_stage_status === 'submitted' ? 'text-cyan-400'
                        : pt.current_stage_status === 'needs_revision' ? 'text-amber-400'
                        : pt.current_stage_status === 'approved' || pt.current_stage_status === 'completed' ? 'text-emerald-400'
                        : 'text-cinema-muted'
                    }`}>
                      {pt.current_stage_status || pt.enrollment_status}
                    </span>
                  </td>
                  <td className="py-3.5 pl-4 text-right">
                    <Link
                      to={`/mentor/enrollments/${pt.enrollment_id}`}
                      className="text-xs text-cinema-gold hover:underline"
                    >
                      {pt.current_stage_status === 'submitted' ? 'Review →' : 'Open →'}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
